export default defineNuxtPlugin(() => {
	useHead({
		script: [
			{
				src: 'https://w227836.yclients.com/widgetJS',
				type: 'text/javascript',
			},
		],
	});
});
